import { render, staticRenderFns } from "./AgregaReferenciaFormComponent.vue?vue&type=template&id=a86412b8"
import script from "./AgregaReferenciaFormComponent.vue?vue&type=script&lang=js"
export * from "./AgregaReferenciaFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports